var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5481_7714",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 130.501C260 202.021 202.021 260 130.501 260C58.9806 260 1.00189 202.021 1.00189 130.501C1.00189 58.9807 58.9806 1.00195 130.501 1.00195C202.021 1.00195 260 58.9807 260 130.501ZM20.1821 130.501C20.1821 191.428 69.5735 240.82 130.501 240.82C191.428 240.82 240.82 191.428 240.82 130.501C240.82 69.5736 191.428 20.1822 130.501 20.1822C69.5735 20.1822 20.1821 69.5736 20.1821 130.501Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 130.501C260 202.021 202.021 260 130.501 260C58.9806 260 1.00189 202.021 1.00189 130.501C1.00189 58.9807 58.9806 1.00195 130.501 1.00195C202.021 1.00195 260 58.9807 260 130.501ZM20.1821 130.501C20.1821 191.428 69.5735 240.82 130.501 240.82C191.428 240.82 240.82 191.428 240.82 130.501C240.82 69.5736 191.428 20.1822 130.501 20.1822C69.5735 20.1822 20.1821 69.5736 20.1821 130.501Z",
    fill: "white",
    stroke: "#ffdc00",
    strokeWidth: 50,
    mask: "url(#path-1-inside-1_5481_7714)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.452 67.4536V67.4536C193.028 63.7541 186.603 64.5432 183.101 69.216C183.083 69.24 183.065 69.2641 183.047 69.2882L111.535 166.412L76.494 121.304V121.304C73.1051 116.538 66.701 115.577 62.1899 119.157C57.6789 122.737 56.7692 129.502 60.158 134.267C60.2858 134.447 60.4188 134.622 60.557 134.793L103.158 190.694V190.694C105.105 193.229 108.035 194.698 111.126 194.686V194.686C114.413 194.841 117.569 193.315 119.606 190.586L199.597 82.6698V82.6698C202.992 77.9093 202.091 71.1431 197.584 67.557C197.54 67.5222 197.496 67.4877 197.452 67.4536V67.4536Z",
    fill: "#ffdc00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickLarge);
export default __webpack_public_path__ + "static/media/tick-large.351cb166d10afc0a719003133c7db8eb.svg";
export { ForwardRef as ReactComponent };